import { render, staticRenderFns } from "./HeaderBurger.vue?vue&type=template&id=16ddb36d&scoped=true"
import script from "./HeaderBurger.vue?vue&type=script&lang=ts"
export * from "./HeaderBurger.vue?vue&type=script&lang=ts"
import style0 from "./HeaderBurger.vue?vue&type=style&index=0&id=16ddb36d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ddb36d",
  null
  
)

export default component.exports